import fwUtil from 'framework-util'

const sentimentTotalService = new fwUtil.ApiService.ApiService('sentimentTotal');


export { sentimentTotalService }
  export function getDataByDate(data){
    return custemRequest({
      url: 'sentimentTotal/list/byDay',
      method: 'get',
      params: data
    })
  }
  export function getEveryData(data){
    return custemRequest({
      url: 'sentimentTotal/list/everyDay',
      method: 'get',
      params: data
    })
  }


// WEBPACK FOOTER //
// ./src/api/pubsentiment/sentimentTotal.js